/**
 * Administrador
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ValidationEmail,
  ValidationMaxLength,
  ValidationPasswordLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import AdministradorSchema from '@/schema/Administrador.schema'

export default class Administrador extends Resource {
  readonly $name: string = 'Administrador'

  readonly $endpoint: string = '/user/administrador{/id}'

  get $schema() {
    return AdministradorSchema(this)
  }

  get $id() {
    return this.idAdministradorPk
  }
  set $id(val: ID) {
    this.idAdministradorPk = val
  }
  get $tag() {
    return this.nome
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idAdministradorPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  @ValidationMaxLength(100)
  @ValidationEmail()
  email: string = ''

  @ResponseHidden()
  @ValidationRequired()
  @ValidationPasswordLength(6, 100)
  senha: string = ''

  @ValidationRequired()
  dataCriacao: string = ''

  async persistAdministrador(model?: Administrador, spinner = 'persistAdministrador') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/administrador`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getAdministrador(id: number, spinner = 'getAdministrador') {
    const fetch = async () => await this.GET(`/user/administrador/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
